import { HomeIcon } from "@volum/hiero";
import StandardNavBar from "../StandardNavBar";

const LINKS = [{ to: "/", label: "Accueil", icon: HomeIcon }];

const BrokersNavBar = () => <StandardNavBar links={LINKS} />;

export default BrokersNavBar;
